module.exports = {
  name: 'masthead-style',
  waitForImages: true,
  transitionHeight: {
    sm: 324,
    md: 550,
    lg: 661
  },
  settings: {
    infinite: true,
    initialSlide: 0,
    centerMode: true,
    centerPadding: 'calc(50vw - 558px)',
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 'xl',
        settings: {
          centerPadding: 'calc(50vw - 478px)'
        }
      },
      {
        breakpoint: 'lg',
        settings: {
          centerPadding: 'calc(50vw - 390px)'
        }
      },
      {
        breakpoint: 'md',
        settings: {
          centerPadding: 'calc(50vw - 272px)'
        }
      },
      {
        breakpoint: 'sm',
        settings: {
          centerPadding: '0'
        }
      },
    ]
  },
}
